import { ActionType, createReducer } from 'typesafe-actions';
import * as SellTransactionActions from './actions';
import { SellDeliveryMethodActionTypes as act } from './actionTypes';
import { SellDeliveryMethodState } from './types';

const initialState: SellDeliveryMethodState = {
  deliveryMethod: '',
};

export default createReducer<
  SellDeliveryMethodState,
  ActionType<typeof SellTransactionActions>
>(initialState)
  .handleAction(
    act.SELECT_DELIVERY_METHOD,
    (state, { payload: { deliveryMethod } }) => {
      return {
        ...state,
        deliveryMethod,
      };
    }
  )
  .handleAction(act.RESET_TRANSACTION, (state) => {
    return {
      ...state,
      deliveryMethod: '',
    };
  });
